{
  "admin.login.redirecting": "Siirrytään kirjautumiseen…",
  "admin.portal.title": "Ylläpito",
  "admin.portal.heading": "Tervetuloa!",
  "admin.portal.tagline": "Valitse, mitä haluat tehdä.",
  "admin.portal.tile.brandLine": "OMA+",
  "admin.portal.tile.service.line": "-palvelu",
  "admin.portal.tile.cms.line": "sisällönhallinta",
  "admin.portal.tile.analytics.line": "analytiikka",
  "admin.portal.tile.feedback.line": "palautteet",
  "admin.portal.tile.analytics.unavailable": "Ei vielä saatavilla",
  "admin.feedback.heading": "OMA+ palautteet",
  "admin.feedback.backToPortal": "Takaisin",
  "admin.feedback.filter.last24Hours": "Viimeinen 24 h",
  "admin.feedback.filter.lastWeek": "Viimeinen viikko",
  "admin.feedback.filter.lastMonth": "Viimeinen kuukausi",
  "admin.feedback.filter.lastSixMonths": "Viimeinen 6 kk",
  "admin.feedback.filter.all": "Kaikki",
  "admin.feedback.filter.custom": "Valitse ajankohta",
  "admin.feedback.filter.from": "Alkaen",
  "admin.feedback.filter.to": "Päättyen",
  "admin.feedback.filter.legend": "Aikaväli",
  "admin.feedback.filter.customSelected": "Valitse ajankohta: {range}",
  "admin.feedback.filter.apply": "Valitse",
  "admin.feedback.filter.cancel": "Peruuta",
  "admin.feedback.filter.validation.missing": "Anna kelvollinen alku- ja loppupäivä.",
  "admin.feedback.filter.validation.reversed": "Alkupäivä ei voi olla loppupäivän jälkeen.",
  "admin.feedback.filter.validation.future": "Tulevia päiviä ei voi valita.",
  "admin.feedback.filter.calendar.selectFromInstruction": "Valitse alkupäivä kalenterista.",
  "admin.feedback.filter.calendar.selectToInstruction": "Valitse loppupäivä kalenterista.",
  "admin.feedback.filter.calendar.fromTo": "Alku- ja loppupäivä",
  "admin.feedback.filter.calendar.previousMonth": "Edellinen kuukausi",
  "admin.feedback.filter.calendar.nextMonth": "Seuraava kuukausi",
  "admin.feedback.filter.calendar.weekdays": "ma ti ke to pe la su",
  "admin.feedback.export": "Vie Exceliin",
  "admin.feedback.exportPending": "Excel-tiedostoa valmistellaan…",
  "admin.feedback.exportFailed": "Excel-vienti epäonnistui. Yritä uudelleen.",
  "admin.feedback.summary.heading": "Palautteiden yhteenveto",
  "admin.feedback.stat.count": "Palautteita",
  "admin.feedback.stat.average": "Keskiarvo (1–5)",
  "admin.feedback.stat.satisfied": "Tyytyväisiä (4–5)",
  "admin.feedback.stat.dissatisfied": "Tyytymättömiä (1–2)",
  "admin.feedback.stat.withText": "Sisältää tekstin",
  "admin.feedback.noRatings": "Tietoa ei saatavilla",
  "admin.feedback.noComparison": "Ei vertailua",
  "admin.feedback.change.up": "Kasvanut numeerisesti",
  "admin.feedback.change.down": "Pienentynyt numeerisesti",
  "admin.feedback.change.neutral": "Ei numeerista muutosta",
  "admin.feedback.change.percentagePoints": " prosenttiyks.",
  "admin.feedback.period.disclosure": "Kuukausi tarkoittaa 30:tä ja kuusi kuukautta 180:tä kulunutta päivää.",
  "admin.feedback.period.finnishTime": "Suomen aika",
  "admin.feedback.period.details": "Lisätiedot valitusta ajanjaksosta",
  "admin.feedback.period.selected": "Valittu ajanjakso",
  "admin.feedback.period.reference": "Vertailujakso",
  "admin.feedback.period.allRetained": "Kaikki säilytetyt palautteet",
  "admin.feedback.period.allRetainedUntil": "Kaikki säilytetyt palautteet asti",
  "admin.feedback.period.timeZone": "Aikavyöhyke Europe/Helsinki. Loppuraja ei sisälly ajanjaksoon.",
  "admin.feedback.metric.open": "Näytä tarkemmat tiedot",
  "admin.feedback.metric.back": "Takaisin",
  "admin.feedback.metric.values": "Arvotaulukko",
  "admin.feedback.metric.period": "Ajanjakso",
  "admin.feedback.metric.missingObservations": "Katkoviiva: välissä ei arvioita.",
  "admin.feedback.metric.contributors.count": "Valitun ajanjakson kaikki palautteet",
  "admin.feedback.metric.contributors.averageRating": "Arvioidut palautteet valitulla ajanjaksolla",
  "admin.feedback.metric.contributors.satisfiedPercentage": "Tyytyväisten palautteet (4–5) valitulla ajanjaksolla",
  "admin.feedback.metric.contributors.dissatisfiedPercentage": "Tyytymättömien palautteet (1–2) valitulla ajanjaksolla",
  "admin.feedback.metric.contributors.withTextCount": "Tekstiä sisältävät palautteet valitulla ajanjaksolla",
  "admin.feedback.metric.unit.count": "määrä",
  "admin.feedback.metric.unit.averageRating": "asteikko 1–5",
  "admin.feedback.metric.unit.percentage": "prosenttia, asteikko 0–100",
  "admin.feedback.metric.granularity.hour": "Tunneittain",
  "admin.feedback.metric.granularity.day": "Päivittäin",
  "admin.feedback.metric.granularity.week": "Viikoittain",
  "admin.feedback.metric.granularity.month": "Kuukausittain",
  "admin.feedback.metric.grouped.hour": "Tunneittain, joka {n}. tunti",
  "admin.feedback.metric.grouped.day": "Päivittäin, joka {n}. päivä",
  "admin.feedback.metric.grouped.week": "Viikoittain, joka {n}. viikko",
  "admin.feedback.metric.grouped.month": "Kuukausittain, joka {n}. kuukausi",
  "admin.feedback.table.date": "Päivämäärä",
  "admin.feedback.table.rating": "Arvosana",
  "admin.feedback.table.text": "Palaute",
  "admin.feedback.table.heading": "Valitun ajanjakson kaikki palautteet",
  "admin.feedback.noRating": "Ei arvosanaa",
  "admin.feedback.noText": "Ei palautetekstiä",
  "admin.feedback.loading": "Ladataan…",
  "admin.feedback.empty": "Ei palautteita valitulla ajanjaksolla.",
  "admin.feedback.error": "Palautteiden lataaminen epäonnistui.",
  "admin.cms.backToPortal": "Päävalikko",
  "admin.forbidden.heading": "Ylläpito – ei todellinen",
  "admin.forbidden.body": "Tämä on esiversion paikkamerkki. Esiversio ei mallinna todellista käyttöoikeustarkistusta eikä sisällä ylläpidon toiminnallisuuksia. Varsinainen ylläpitonäkymä on erillinen tuotantopalvelu eikä kuulu tähän esiversioon.",
  "admin.forbidden.navigation": "Palaa etusivulle päänavigaatiosta."
}
